import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
//import * as Icon from 'react-feather';
import * as Icon from '@heroicons/react/outline';

import './styles.css';
import { colors } from '../../styles/colors';

/**
 * Side navigation component. Provides an experience such as
 * an Off Canvas.
 */
const OffCanvasItem = ({
  label,
  icon,
  linkTo,
  isActive,
  staff,
  badge,
  badgeTitle
}) => {
  // Staff items (Keenvil only) use the brand violet to tell them apart.
  const itemClass = classNames('kv-offcanvas__item', {
    'kv-offcanvas__item--active': isActive,
    'kv-offcanvas__item--staff': staff
  });

  return (
    <Link className={itemClass} to={linkTo}>
      {badge ? (
        // Pendientes del módulo (ej. Multas: actas por confirmar + descargos).
        <b className="kv-offcanvas__badge" title={badgeTitle}>
          {badge > 99 ? '99+' : badge}
        </b>
      ) : null}
      {icon === 'home' ? (
        <Icon.HomeIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'car' ? (
        <Icon.TruckIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'users' ? (
        <Icon.UserIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'chat' ? (
        <Icon.NewspaperIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'arrows' ? (
        <Icon.SwitchHorizontalIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'box' ? (
        <Icon.UserGroupIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'criminal' ? (
        <Icon.ScaleIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'calendar' ? (
        <Icon.CalendarIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'settings' ? (
        <Icon.AdjustmentsIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'blacklist' ? (
        <Icon.BanIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'fines' ? (
        <Icon.DocumentTextIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : icon === 'staff' ? (
        <Icon.ShieldCheckIcon
          className="kv-offcanvas__item__icon"
          color={colors.keenvil}
        />
      ) : icon === 'help' ? (
        <Icon.QuestionMarkCircleIcon
          className="kv-offcanvas__item__icon"
          color={isActive ? colors.main : colors.disabled}
        />
      ) : null}
      <span>{label}</span>
    </Link>
  );
};

const OffCanvasNavigation = ({ children, expanded }) => {
  const menuClass = classNames('kv-offcanvas', {
    'kv-offcanvas--expanded': expanded
  });
  return <div className={menuClass}>{children}</div>;
};

OffCanvasItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isExpanded: PropTypes.bool,
  staff: PropTypes.bool,
  badge: PropTypes.number,
  badgeTitle: PropTypes.string
};

OffCanvasItem.defaultProps = {
  label: '',
  icon: 'question',
  linkTo: '/',
  isActive: false,
  isExpanded: false,
  staff: false
};

OffCanvasNavigation.defaultProps = {
  expanded: false
};

OffCanvasNavigation.propTypes = {
  expanded: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element)
};

export { OffCanvasItem };
export default OffCanvasNavigation;
